export const MATERIAL_ITEMS_PATH = "/produce/production/material-items";
export const SUPPLIER_PRICE_IMPORTS_PATH = "/produce/production/supplier-price-imports";
export const SUPPLIER_PRICE_IMPORT_LABEL = "supplier price import";
export const SUPPLIER_PRICE_IMPORT_APPLY_LABEL = "apply results";
export const SUPPLIER_PRICE_IMPORT_DECISION_LABEL = "row decision";
export const SUPPLIER_PRICE_IMPORT_PRICE_REVIEW_LABEL = "row price review";
export const SUPPLIER_PRICE_IMPORT_SELECTION_LABEL = "row selection";
export const SUPPLIER_PRICE_IMPORT_HELD_ROWS_LABEL = "rows not ready";
export const SUPPLIER_PRICE_IMPORTS_LABEL = "supplier price imports";
export const SUPPLIER_PRICES_TODAY_LABEL = "current prices";
export const PRICING_CALC_DECIMALS_LABEL = "pricing calculation decimals setting";
export const SUPPLIER_PRICE_IMPORT_CANDIDATES_LABEL = "matching materials";
export const MATCHED_MATERIAL_LABEL = "matched material";
export const SUPPLIER_PRICE_IMPORT_ROWS_LABEL = "supplier price import rows";
export const VENDORS_LABEL = "vendors";
